// extracted by mini-css-extract-plugin
export default {"wrapper":"MainSearchFormV2_wrapper__7NyD3","container":"MainSearchFormV2_container__F7s48","row":"MainSearchFormV2_row__fc4jp"};